import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";

import appReducer from "./AppReducer";

const rootReducer = (state: any, action: any) => {

  if(action.type === "reset") {
    state = undefined;
  }

  return appReducer(state, action);
}

export const store = configureStore({
  reducer: { reducer: rootReducer }
});

export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>;
